<div class="menu">
  <nav class="navigation-container">
    <a
      *ngFor="let sideBarItem of items"
      class="btn btn-side-navigation p-0 me-4 me-sm-5"
      [routerLink]="sideBarItem.routerLink"
      [routerLinkActive]="['active']">
      <div class="d-flex flex-column align-items-center">
        <i-tabler
          *ngIf="sideBarItem?.icon"
          [name]="sideBarItem.icon"
          class="icon"></i-tabler>
        <span class="label d-inline d-lg-inline">{{ sideBarItem.label | translate }}</span>
      </div>
    </a>
  </nav>
</div>
